import React from 'react';
import theme from '../Shared/theme.js';
import { ThemeProvider } from '@mui/material/styles';
import TopBar from './TopBar';
import AgentDetails from '../Components/AgentDetails';
// import DestChart from '../Components/DestChart';
import DestinationTable from '../Components/DestinationTable.jsx';
// import PieChart from '../Components/PieChart';
import PackageSummaryTable from '../Components/PackageSummaryTable';
import VarianceCard from '../Components/VarianceCard';
import AgentCommissionChart from '../Components/AgentCommissionChart';
import AgentRecentActivity from '../Components/AgentRecentActivity';
import AgentCommissionTable from '../Components/AgentCommissionTable';
import DepartureNote from '../Components/Note-Msg.jsx';
import '../Shared/CommonStyle.css';

const Layout = ({ user, onLogout }) => {
  return (
    <ThemeProvider theme={theme}>
      <div className="layout-container">
        <TopBar username={user} onLogout={onLogout} />
        <div className="body-container">
          <DepartureNote />
          <div className="first-row">
            <AgentDetails username={user} />
            <div className="row-container">
              <div className="bar-container">
                <AgentCommissionChart username={user} />
              </div>
              <div className="pie-container">
                <PackageSummaryTable username={user} />
              </div>
              <div className="activity-table-container">
                <AgentRecentActivity username={user} />
              </div>
            </div>
          </div>
          <div className="first-row">
            <div className="row-container">
              <div className="dst-container">
                <DestinationTable username={user} />
              </div>
              <div className="activity-container">
                <VarianceCard username={user} />
              </div>
            </div>
          </div>
          <div className="table-container">
            <AgentCommissionTable username={user} />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Layout;
